import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';

// show information for the user that
class DashboardInitLocations extends React.Component {
  render() {
    const {
      intl: { messages },
      appIntl,
      history,
    } = this.props;

    return (
      <div class="jumbotron">
        <Grid fluid class="m-b-20 m-t-20">
          <Row>
            <Col lg={6} class="bg-white">
              <div class="padding-30 text-center">Nice video here</div>
            </Col>
            <Col lg={6}>
              <div class="card card-transparent">
                <div class="card-header">
                  <div class="card-title">{messages.getting_started}</div>
                </div>
                <div class="card-block">
                  <h3>{messages.set_your_locations}</h3>
                  <p>{messages.set_up_locations_for_your_car_business_set_services_opening_hours_upload_photos}</p>
                  <div class="text-right p-t-15">
                    <Button
                      bsStyle="primary"
                      onClick={() => history.push(appIntl.urlPrefix + 'account/settings/locations')}
                    >
                      <i class="fal fa-map m-r-10" /> {messages.settings}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardInitLocations)));
